import React from "react";
import { Form } from "react-bootstrap";

const ExtraInfoSection = (props) => {
  return (
    <div>
      {(props.mode === "update" && props.typeOfModal === "NotFranchise") ||
        (props.mode === "add" && (props.requestType == "AddKCUser" || props.requestType == "AddHomeOfficeUser") && (
          <Form.Group>
            Where is this user's desk located?
            <Form.Control
              type="text"
              onChange={(e) =>
                props.setUser((prevUserToUpdate) => ({
                  ...prevUserToUpdate,
                  officeSpace: e.target.value,
                }))
              }
            />
          </Form.Group>
        ))}
      <Form.Group className="my-2">
        Who should be notified when this is completed?
        <Form.Control
          type="text"
          onChange={(value) =>
            props.setUser((prevUser) => ({
              ...prevUser,
              notify: value.target.value,
            }))
          }
        />
      </Form.Group>
      <Form.Group className="my-2">
        Who Do They Directly Report To?
        <Form.Control
          type="text"
          onChange={(value) =>
            props.setUser((prevUser) => ({
              ...prevUser,
              directReport: value.target.value,
            }))
          }
        />
      </Form.Group>
      <Form.Group className="my-2">
        Special Instructions
        <Form.Control
          as="textarea"
          onChange={(value) =>
            props.setUser((prevUser) => ({
              ...prevUser,
              specialInstruction: value.target.value,
            }))
          }
        />
      </Form.Group>
    </div>
  );
};

export default ExtraInfoSection;
